import ServiceRequest from "../../app/services/index";
import { ApiPath, METHOD } from "../../app/config/apiPath";
import { ParserInterface } from "../../app/duck/types";
import { ApiConfig } from "../../app/config/apiConfig";
import { CreateSaveViewPayloadType, GSCPayloadType, UpdateSaveViewPayloadType } from "./types";

class Apis {
    public *getGSCReportData(
        parser: ParserInterface,
        payload: GSCPayloadType
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.POST,
            data: {
                ...payload,
            },
            url: ApiPath.GET_GSC_DATA.replace("{{tenantCode}}", parser.tenantCode),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *downloadGSCReportData(
        parser: ParserInterface,
        payload: GSCPayloadType
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.POST,
            data: {
                ...payload,
            },
            responseType: "blob",
            url: ApiPath.DOWNLOAD_GSC_DATA.replace("{{tenantCode}}", parser.tenantCode),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *getGSCSavedViewsList(
        parser: ParserInterface,
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.GET,
            url: ApiPath.GSC_SAVED_VIEWS.replace("{{tenantCode}}", parser.tenantCode),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *getGSCTenantDetails(
        parser: ParserInterface,
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.GET,
            url: ApiPath.GSC_TENANT_DETAILS.replace("{{tenantCode}}", parser.tenantCode),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *createGSCSavedView(
        parser: ParserInterface,
        payload: CreateSaveViewPayloadType
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.POST,
            data: payload,
            url: ApiPath.GSC_SAVED_VIEWS.replace("{{tenantCode}}", parser.tenantCode),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *getGSCSavedViewDetails(
        parser: ParserInterface,
        payload: { viewId: string; }
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.GET,
            url: ApiPath.GSC_SAVED_VIEW_DETAILS
                .replace("{{tenantCode}}", parser.tenantCode)
                .replace("{{viewId}}", payload.viewId),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *updateGSCSavedView(
        parser: ParserInterface,
        viewId: string,
        payload: UpdateSaveViewPayloadType
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.PUT,
            data: payload,
            url: ApiPath.GSC_SAVED_VIEW_DETAILS
                .replace("{{tenantCode}}", parser.tenantCode)
                .replace("{{viewId}}", viewId),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }

    public *deleteGSCSavedView(
        parser: ParserInterface,
        viewId: string
        // tslint:disable-next-line:no-any
    ): any {
        const axiosParam = {
            baseURL: ApiConfig.baseURL,
            method: METHOD.DELETE,
            url: ApiPath.GSC_SAVED_VIEW_DETAILS
                .replace("{{tenantCode}}", parser.tenantCode)
                .replace("{{viewId}}", viewId),
        };
        const response = yield ServiceRequest.invoke(axiosParam);
        return response;
    }
}
export default new Apis();
